<template>
  <a-row class="content-wrapper" type="flex" justify="center" align="top">
    <a-col :lg={span:12} >
      
      <h1>{{post.title}}</h1>
      <br>
      <p v-html="post.content"></p>
    </a-col>
  </a-row>
</template>

<script>
import firebase from '@/configs/firebase-setup'
const db = firebase.firestore()

export default {
  props: ['postId'],
  data(){
    return {
      post: {}
    }
  },

  mounted(){
    this.getPost()
  },

  methods:{
    getPost(){
      db.collection('posts')
        .doc(this.postId)
        .get()
        .then(result=>{
          this.post = result.data()
        })
    }
  }
}
</script>

<style scoped>
.content-wrapper{
  padding: 2em;
  font-family: 'ZCOOL QingKe HuangYou', cursive;
  font-size: 20pt;
}
</style>

